import React, { useEffect, useState, useRef } from 'react';
import ChatBody from './ChatBody';
import ChatInput from './ChatInput';
import FooterSlot from './FooterSlot';
import '../styles/chat.css';
import { BACKEND_WS_URL } from '../config';

function ChatWidget() {
  // console.log("ChatWidget")
  const [messages, setMessages] = useState([
    // { id: '1', message: '你好，我是极智未来智能客服，很高兴能为你服务。', isUser: false },
    // { id: '2', message: '你好，有什么我可以帮到你？', isUser: false },
    // { id: '3', message: '我想了解一下今天的天气。', isUser: true },
    // { id: '4', message: '今天天气晴朗，温度适宜。', isUser: false },
  ]);
  const [isThinking, setIsThinking] = useState(false);
  const wsRef = useRef(null); // Use wsRef.current directly, remove ws state
  const messageIdRef = useRef(messages.length + 1);

  const streamDelay = 30; // 渲染延迟，单位毫秒
  const renderIntervalRef = useRef(null);             // 定时器引用
  const streamFifoBuffer = useRef([]);                // 流式数据缓冲区 (FIFO)

  const streamDone = useRef(true);
  const pendingMessage = useRef(null); // Ref to store pending message

  const urlParams = new URLSearchParams(window.location.search);
  const bot_id = urlParams.get('bot_id') || '0'; // Use 'bot_id' from URL, default to '0'
  const prompt_template = urlParams.get('prompt') || null; // 从URL获取prompt参数

  const createWebSocket = () => {
    // 构建WebSocket URL，支持prompt参数
    // let ws_url = `${BACKEND_WS_URL}?model=gemini-2.0-flash-thinking-exp-01-21`;
    let ws_url = `${BACKEND_WS_URL}`;
    if (prompt_template) {
      ws_url += `&prompt=${encodeURIComponent(prompt_template)}`;
    }
    console.log('WebSocket URL with prompt:', ws_url);
    const newWs = new WebSocket(ws_url);

    newWs.onopen = () => {
      console.log('WebSocket connection opened, bot id=', bot_id);
      newWs.send(JSON.stringify({ bot_id }));

      if (pendingMessage.current) {
        console.log('Sending pending message with full context after reconnection:', pendingMessage.current);
        // 将完整的 messages 数组和新的用户输入组合成 JSON 发送
        const fullContext = [
          ...messages.map(msg => ({ role: msg.isUser ? 'user' : 'assistant', content: msg.message })),
          { role: 'user', content: pendingMessage.current }
        ];
        sendMessage(JSON.stringify(fullContext));
        pendingMessage.current = null;
      }
    };


    newWs.onclose = () => {
      console.log('WebSocket connection closed');
      setIsThinking(false);
    };

    newWs.onmessage = (event) => {
      console.log('WebSocket received message:', event.data);
      const receivedMessage = event.data.trim();

      if (receivedMessage === '思考中...') {
        console.log('Received "思考中..." from backend');
      } else if (receivedMessage === '[STREAM_DONE]') {
        streamDone.current = true;
        setIsThinking(false);
      } else {
        try {
          const messageData = JSON.parse(receivedMessage);
          if (messageData.role === 'assistant' && messageData.content) {
            console.log('Received welcome message:', messageData.content);
            setMessages((prevMessages) => [
              ...prevMessages,
              { id: (messageIdRef.current++).toString(), message: messageData.content, isUser: false },
            ]);
          } else if (receivedMessage.length > 0) {
            streamFifoBuffer.current.push(receivedMessage);
            console.log('receivedMessage.length > 0');
          }
        } catch (error) {
          console.warn('Failed to parse message as JSON, processing as text:', receivedMessage);
          streamFifoBuffer.current.push(receivedMessage);
        }
      }
    };

    newWs.onerror = (error) => {
      console.error('WebSocket error:', error);
      setIsThinking(false);
    };
    return newWs; // Return the new WebSocket instance
  };


  useEffect(() => {
    wsRef.current = createWebSocket(); // Initialize WebSocket using createWebSocket function

    return () => {
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close();
      }
      clearInterval(renderIntervalRef.current);
      renderIntervalRef.current = null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sendMessage = (message) => {
    wsRef.current.send(message); // Use wsRef.current

    if (renderIntervalRef.current) clearInterval(renderIntervalRef.current);

    renderIntervalRef.current = setInterval(() => {
      if (streamFifoBuffer.current.length > 0) {
        const nextChunk = streamFifoBuffer.current.shift();
        setMessages((prevMessages) => {
          const lastMessage = prevMessages[prevMessages.length - 1];
          if (lastMessage && !lastMessage.isUser) {
            const updatedLastMessage = { ...lastMessage, message: lastMessage.message + nextChunk };
            return [...prevMessages.slice(0, -1), updatedLastMessage];
          } else {
            return [...prevMessages, { id: (messageIdRef.current++).toString(), message: nextChunk, isUser: false }];
          }
        });
      }
      else{
        if (streamDone.current){
          clearInterval(renderIntervalRef.current);
        }
      }
    }, streamDelay);
  };

  const handleUserMessage = (message) => {
    const userMessage = {
      id: (messageIdRef.current++).toString(),
      message: message.trim(),
      isUser: true,
    };

    setMessages((prevMessages) => {
      const updatedMessages = [...prevMessages, userMessage];
      return updatedMessages;
    });

    streamDone.current = false;
    setIsThinking(true);

    if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
      console.log('WebSocket not open, attempting to reconnect in handleUserMessage');
      pendingMessage.current = message; // Store message to send after reconnection
      wsRef.current = createWebSocket(); // Reconnect using createWebSocket function
      return; // Exit, message will be sent on onopen after reconnection
    }

    sendMessage(message); // Send message if WebSocket is already open
  };

  return (
    <div className="chat-widget" style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* <ChatHeader /> */}
      <ChatBody messages={messages} isThinking={isThinking} style={{ flex: 1, overflowY: 'auto' }} />
      <ChatInput onSendMessage={handleUserMessage} style={{ position: 'sticky', bottom: 0, zIndex: 1 }} /> {/* Use wsRef.current */}
      <FooterSlot />
    </div>
  );
}

export default ChatWidget;
